/* ============================================================
   JUSTYOL REDESIGN — header behaviors (vanilla JS, no frameworks)
   - announcement rotation
   - hide-on-scroll (mobile)
   - search trending dropdown
   - mobile menu sheet open/close
   - language toggle (localization form submit)
   ============================================================ */
(function () {
  'use strict';

  var mqSm = window.matchMedia('(max-width: 767px)');

  /* ---------- announcement rotation (desktop) ---------- */
  function initAnnouncement() {
    var ann = document.querySelector('.jy-hdr__ann');
    if (!ann) return;
    var msgs = ann.querySelectorAll('.jy-ann__msg');
    if (msgs.length === 0) return;
    var i = 0;
    msgs[0].classList.add('on');
    if (msgs.length < 2) return;
    setInterval(function () {
      if (mqSm.matches) return; // mobile shows the single short line
      msgs[i].classList.remove('on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('on');
    }, 4000);
  }

  /* ---------- publish header height so sticky content (PDP gallery,
       collection bars) can offset below the sticky header ---------- */
  function initHeaderHeight() {
    var hdr = document.querySelector('.jy-hdr');
    if (!hdr) return;
    var set = function () {
      document.documentElement.style.setProperty('--jy-header-h', Math.round(hdr.getBoundingClientRect().height) + 'px');
    };
    set();
    window.addEventListener('resize', set, { passive: true });
    window.addEventListener('load', set);
  }

  /* ---------- publish the announcement-strip height so the sticky header can
       slide it off the top on scroll (CSS negative sticky top) with NO layout
       jump — nothing collapses, the whole header just scrolls up by that much.
       Also publishes the condensed header height (main + nav rows) so the
       pinned collection bar sits flush below them. ---------- */
  function initHeaderAnnSlide() {
    var hdr = document.querySelector('.jy-hdr');
    if (!hdr) return;
    var ann = hdr.querySelector('.jy-hdr__ann');
    var root = document.documentElement;
    var measure = function () {
      var annH = ann && !mqSm.matches ? Math.round(ann.getBoundingClientRect().height) : 0;
      var fullH = Math.round(hdr.getBoundingClientRect().height);
      root.style.setProperty('--jy-annh', annH + 'px');
      /* height the collection bar pins under = header minus the slid-off strip */
      root.style.setProperty('--jy-headerh-pinned', fullH - annH + 'px');
    };
    measure();
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('load', measure);
  }

  /* ---------- hide on scroll down, return on scroll up (mobile) ---------- */
  function initHideOnScroll() {
    var hdr = document.querySelector('.jy-hdr');
    if (!hdr) return;
    if (hdr.hasAttribute('data-jy-no-hide')) return;
    var root = document.documentElement;
    var lastY = window.scrollY || 0;
    // flag <html> too so page-level sticky bars (e.g. the collection filter
    // bar) can rise to the top while the header is hidden
    var setHidden = function (hidden) {
      hdr.classList.toggle('jy-hdr--hidden', hidden);
      root.classList.toggle('jy-hdr-off', hidden);
    };
    window.addEventListener(
      'scroll',
      function () {
        if (!mqSm.matches) {
          setHidden(false);
          return;
        }
        var y = window.scrollY || 0;
        if (y > lastY && y > 130) {
          setHidden(true);
        } else if (y < lastY - 4) {
          setHidden(false);
        }
        lastY = y;
      },
      { passive: true }
    );
  }

  /* ---------- search: trending (empty) + live autocomplete ---------- */
  function initSearchAutocomplete() {
    var search = document.querySelector('[data-jy-search]') || document.querySelector('.jy-hdr__search');
    if (!search) return;
    var input = search.querySelector('input[name="q"]');
    var panel = search.querySelector('.jy-trending');
    var ac = search.querySelector('[data-jy-ac]');
    if (!input || !panel || !ac) return;
    var trending = panel.querySelector('[data-jy-trending]');
    var recents = document.createElement('div');
    recents.className = 'jy-recents';
    recents.hidden = true;
    panel.insertBefore(recents, panel.firstChild);

    var suggestUrl = search.getAttribute('data-suggest-url') || '/search/suggest';
    var searchUrl = search.getAttribute('data-search-url') || '/search';
    var seeAll = search.getAttribute('data-seeall') || 'See all results';
    var noResults = search.getAttribute('data-noresults') || 'No results';
    var cur = search.getAttribute('data-cur') || '';
    var recentLabel = search.getAttribute('data-recent') || 'Recent';
    var clearLabel = search.getAttribute('data-clear') || 'Clear';

    /* recent searches (localStorage) */
    var RKEY = 'jy_recent_searches';
    var getRecent = function () {
      try {
        return JSON.parse(localStorage.getItem(RKEY) || '[]') || [];
      } catch (e) {
        return [];
      }
    };
    var setRecent = function (a) {
      try {
        localStorage.setItem(RKEY, JSON.stringify(a.slice(0, 8)));
      } catch (e) {}
    };
    var saveRecent = function (term) {
      term = (term || '').trim();
      if (!term) return;
      var a = getRecent().filter(function (t) {
        return t.toLowerCase() !== term.toLowerCase();
      });
      a.unshift(term);
      setRecent(a);
    };

    // Predictive JSON returns price either as a pre-formatted money string
    // ("129,00 Dhs") or as integer cents — normalise to whole units, no decimals
    var fmtPrice = function (v) {
      if (v == null || v === '') return '';
      var out;
      if (typeof v === 'number') {
        out = String(Math.round(v / 100));
      } else {
        out = String(v).replace(/[.,]00(?=\s|\D|$)/, '').trim();
      }
      // append the currency when the value is bare digits (no currency text/symbol yet)
      if (cur && !/[a-zA-Z؀-ۿ$€£]/.test(out)) {
        out = out + ' ' + cur;
      }
      return out;
    };

    var open = function () {
      panel.classList.add('open');
      panel.setAttribute('aria-hidden', 'false');
    };
    var close = function () {
      panel.classList.remove('open');
      panel.setAttribute('aria-hidden', 'true');
    };
    var esc = function (s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    };
    var renderRecent = function () {
      var a = getRecent();
      if (!a.length) {
        recents.hidden = true;
        recents.innerHTML = '';
        return;
      }
      var chips = a
        .map(function (t) {
          return (
            '<span class="jy-recent-chip"><a href="' + searchUrl + '?q=' + encodeURIComponent(t) + '&options[prefix]=last">' +
            esc(t) +
            '</a><button type="button" class="jy-recent-x" data-term="' + esc(t) + '" aria-label="remove">' +
            '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
            '</button></span>'
          );
        })
        .join('');
      recents.innerHTML =
        '<div class="jy-recents__head"><p class="jy-trending__title">' + esc(recentLabel) + '</p>' +
        '<button type="button" class="jy-recents__clear" data-jy-recent-clear>' + esc(clearLabel) + '</button></div>' +
        '<div class="jy-trending__chips">' + chips + '</div>';
      recents.hidden = false;
    };
    var showTrending = function () {
      renderRecent();
      if (trending) trending.hidden = false;
      ac.hidden = true;
    };
    var showResults = function () {
      recents.hidden = true;
      if (trending) trending.hidden = true;
      ac.hidden = false;
    };

    var token = 0;
    var timer = null;
    var cache = {};

    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [];
      var queries = r.queries || [];
      var html = '';
      queries.slice(0, 4).forEach(function (qq) {
        html +=
          '<a class="jy-ac__q" href="' + esc(qq.url) + '">' +
          '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
          '<span>' + esc(qq.text) + '</span></a>';
      });
      products.forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var price = fmtPrice(p.price);
        var compare =
          p.compare_at_price && p.compare_at_price !== p.price ? fmtPrice(p.compare_at_price) : '';
        html +=
          '<a class="jy-ac__item" href="' + esc(p.url) + '">' +
          (img
            ? '<img src="' + esc(img) + '" alt="" width="44" height="55" loading="lazy">'
            : '<span class="jy-ac__noimg" aria-hidden="true"></span>') +
          '<span class="jy-ac__body">' +
          '<span class="jy-ac__t">' + esc(p.title) + '</span>' +
          '<span class="jy-ac__meta">' +
          (p.vendor ? '<span class="jy-ac__v">' + esc(p.vendor) + '</span>' : '') +
          (price
            ? '<span class="jy-ac__price">' + esc(price) + (compare ? ' <s>' + esc(compare) + '</s>' : '') + '</span>'
            : '') +
          '</span>' +
          '</span></a>';
      });
      if (!products.length && !queries.length) {
        html = '<div class="jy-ac__empty">' + esc(noResults) + '</div>';
      }
      html +=
        '<a class="jy-ac__all" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(q) + '&options[prefix]=last">' +
        esc(seeAll) + ' « ' + esc(q) + ' »</a>';
      ac.innerHTML = html;
      showResults();
    }

    function suggest(q) {
      if (cache[q]) {
        render(q, cache[q]);
        return;
      }
      var mine = ++token;
      var url =
        suggestUrl +
        '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=last' +
        /* also match on variant SKU (+ title/vendor/type) so shoppers can search
           by reference code, not just product name */
        '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (mine !== token) return;
          cache[q] = data;
          render(q, data);
        })
        .catch(function () {
          /* keep the previous state on a network hiccup */
        });
    }

    input.addEventListener('focus', function () {
      open();
      var q = input.value.trim();
      if (q) {
        showResults();
        suggest(q);
      } else {
        showTrending();
      }
    });
    input.addEventListener('input', function () {
      var q = input.value.trim();
      open();
      if (!q) {
        showTrending();
        return;
      }
      clearTimeout(timer);
      timer = setTimeout(function () {
        suggest(q);
      }, 200);
    });
    document.addEventListener('click', function (e) {
      if (!search.contains(e.target)) close();
    });
    /* keyboard: tabbing out of the search (past the last chip) closes it,
       like clicking elsewhere does. Listen for focus ARRIVING elsewhere, not
       focus leaving the input: Safari/iOS don't focus a tapped link, so a
       focusout-based close hid the panel before a suggestion tap landed. */
    document.addEventListener('focusin', function (e) {
      if (!search.contains(e.target)) close();
    });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') {
        close();
        input.blur();
      }
    });

    // remember what was searched
    var form = search.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        saveRecent(input.value);
      });
    }
    ac.addEventListener('click', function (e) {
      // any product / query / "see all" click counts as a search
      if (e.target.closest('a')) saveRecent(input.value);
    });
    // recent-chip remove (×) + clear all
    recents.addEventListener('click', function (e) {
      var rm = e.target.closest('.jy-recent-x');
      if (rm) {
        e.preventDefault();
        var term = rm.getAttribute('data-term') || '';
        setRecent(
          getRecent().filter(function (t) {
            return t.toLowerCase() !== term.toLowerCase();
          })
        );
        renderRecent();
        return;
      }
      if (e.target.closest('[data-jy-recent-clear]')) {
        e.preventDefault();
        setRecent([]);
        renderRecent();
      }
    });
  }

  /* ---------- mobile menu sheet ---------- */
  function initMobileMenu() {
    var menu = document.getElementById('jy-mmenu');
    var scrim = document.getElementById('jy-mmenu-scrim');
    if (!menu || !scrim) return;

    var setExpanded = function (v) {
      var openers = document.querySelectorAll('[data-jy-mmenu-open]');
      for (var i = 0; i < openers.length; i++) openers[i].setAttribute('aria-expanded', v ? 'true' : 'false');
    };
    var openMenu = function () {
      menu.classList.add('open');
      scrim.classList.add('open');
      document.documentElement.classList.add('jy-no-scroll');
      document.body.style.overflow = 'hidden';
      setExpanded(true);
    };
    var closeMenu = function () {
      menu.classList.remove('open');
      scrim.classList.remove('open');
      document.documentElement.classList.remove('jy-no-scroll');
      document.body.style.overflow = '';
      setExpanded(false);
    };

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-jy-mmenu-open]');
      if (opener) {
        e.preventDefault();
        openMenu();
        return;
      }
      if (e.target.closest('[data-jy-mmenu-close]')) {
        e.preventDefault();
        closeMenu();
      }
    });
    scrim.addEventListener('click', closeMenu);
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    /* two-panel category browser: tap a department on the left → show its
       sub-category panel on the right (no page load, no nested accordions) */
    var two = menu.querySelector('[data-jy-mmenu2]');
    if (two) {
      var depts = two.querySelectorAll('[data-jy-dept]');
      var panels = two.querySelectorAll('[data-jy-panel]');
      var panelsWrap = two.querySelector('.jy-mmenu2__panels');
      two.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-jy-dept]');
        if (!btn) return;
        var idx = btn.getAttribute('data-jy-dept');
        for (var i = 0; i < depts.length; i++) {
          var on = depts[i] === btn;
          depts[i].classList.toggle('on', on);
          depts[i].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        for (var j = 0; j < panels.length; j++) {
          panels[j].classList.toggle('on', panels[j].getAttribute('data-jy-panel') === idx);
        }
        if (panelsWrap) panelsWrap.scrollTop = 0;
      });
    }
  }

  /* ---------- mobile back button (subpages) ---------- */
  function initBackButton() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-jy-back]');
      if (!btn) return;
      e.preventDefault();
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    });
  }

  /* ---------- language toggle ----------
     Navigate (GET) to the target locale's URL instead of POSTing the Shopify
     localization form. The iOS app intercepts non-app-param navigations and
     re-issues them via loadUrl (a GET), which drops the POST body of the
     localization form -> /localization 404s. A direct GET to the locale-
     prefixed URL switches the language on both platforms and can't be
     mangled. Falls back to the form POST if we can't build the target. */
  function initLangToggle() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-jy-locale]');
      if (!btn) return;
      e.preventDefault();
      var code = btn.getAttribute('data-jy-locale');
      var form = btn.closest('form');
      var curBtn = form && form.querySelector('[data-jy-locale].on');
      /* already on this language */
      if (curBtn && curBtn.getAttribute('data-jy-locale') === code) return;
      /* remember the manual choice (honoured by the head script in theme.liquid) */
      try {
        document.cookie = 'jy_lang=' + encodeURIComponent(code) + ';path=/;max-age=31536000;samesite=lax';
        localStorage.setItem('jy_lang', code);
      } catch (er) { /* noop */ }

      var targetRoot = btn.getAttribute('data-jy-root') || '/';
      var curRoot = (curBtn && curBtn.getAttribute('data-jy-root')) || '/';
      /* strip the current locale prefix, then prepend the target's */
      var path = location.pathname;
      if (curRoot !== '/' && path.indexOf(curRoot) === 0) path = path.slice(curRoot.length) || '/';
      var prefRoot = targetRoot === '/' ? '' : targetRoot;
      var target = prefRoot + path + location.search + location.hash;

      if (btn.getAttribute('data-jy-root') === null || target === location.pathname + location.search + location.hash) {
        /* no root info, or same URL — fall back to the native form POST */
        if (form) {
          var input = form.querySelector('input[name="locale_code"]');
          if (input) input.value = code;
          form.submit();
        }
        return;
      }
      location.assign(target);
    });
  }

  /* wishlist count badge (native-wishlist.js stores items in localStorage) */
  function initWishCount() {
    var badges = document.querySelectorAll('[data-jy-wish-count]');
    if (!badges.length) return;
    function update() {
      var count = 0;
      try {
        var items = JSON.parse(localStorage.getItem('justyol_wishlist') || '[]');
        count = Array.isArray(items) ? items.length : 0;
      } catch (e) {
        /* noop */
      }
      badges.forEach(function (b) {
        b.textContent = count > 99 ? '99+' : String(count);
        b.hidden = count === 0;
      });
    }
    update();
    ['wishlist:added', 'wishlist:removed', 'wishlist:cleared'].forEach(function (ev) {
      window.addEventListener(ev, update);
    });
    window.addEventListener('storage', function (e) {
      if (e.key === 'justyol_wishlist') update();
    });
  }

  function init() {
    initAnnouncement();
    initHeaderHeight();
    initHideOnScroll();
    initHeaderAnnSlide();
    initSearchAutocomplete();
    initMobileMenu();
    initBackButton();
    initLangToggle();
    initWishCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
